module.exports = __webpack_public_path__ + "static/media/4.11c368e7.svg";